import Component from './paginator.vue';
Vue.component(Component.name, Component);